import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propNumber, propStr } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const SolutionTabContent = (props) => {
    const { currentIndex, tabIndex, text } = props;
    if (tabIndex !== currentIndex) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'tab-content' }, { children: _jsx(SplitText, { text: text }) })));
};
SolutionTabContent.propTypes = {
    currentIndex: propNumber().isRequired,
    tabIndex: propNumber().isRequired,
    text: propStr(),
};
SolutionTabContent.defaultProps = {
    text: '',
};
export default SolutionTabContent;
